export const ALLOWED_BENCHMARK_COUNTRIES = ['BE', 'DE', 'NL'];
